// extracted by mini-css-extract-plugin
export var card = "Card-module--card--YnO1I";